// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2AHNg","range":"MonthRangeSwitch_range__2Ngiy","disabled":"MonthRangeSwitch_disabled__31w7A"};